/* FFD UI v2: cart adds, added-to-cart sheet with one upsell, sticky buy bar, product page (plans + smart add-on), gallery, kitchen map kit builder. */
(function () {
  var D = window.FXD || { p: {}, up: {} };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var money = function (cents) { var v = cents / 100; return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); };

  /* ---------- cart ---------- */
  function refreshBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var el = document.getElementById('cart-icon-bubble'); if (!el) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var inner = doc.querySelector('.shopify-section'); if (inner) el.innerHTML = inner.innerHTML;
  }
  function add(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { refreshBubble(j.sections); return j; });
  }

  /* ---------- added-to-cart sheet ---------- */
  var sheet, lastFocus;
  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'fx fx-sheet'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-labelledby', 'fx-sheet-t');
    sheet.innerHTML = '<div class="fx-sheet__bg" data-fx-close></div><div class="fx-sheet__panel" tabindex="-1">' +
      '<div class="fx-sheet__hd"><p class="fx-sheet__ok" id="fx-sheet-t">Added to cart</p><button class="fx-sheet__x" type="button" aria-label="Close" data-fx-close>&times;</button></div>' +
      '<div class="fx-sheet__item"></div><div class="fx-sheet__btns"><a class="fx-btn fx-btn--block" href="' + root + 'checkout">Checkout</a>' +
      '<a class="fx-btn fx-btn--line fx-btn--block fx-btn--sm" href="' + root + 'cart">View cart</a></div><div class="fx-sheet__upw"></div>' +
      '<p class="fx-sheet__ship">Free US shipping over $35 and a 30-day money-back guarantee</p></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-fx-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
  }
  function closeSheet() { sheet.classList.remove('is-open'); if (lastFocus) lastFocus.focus(); }
  function openSheet(list, upsellFor) {
    if (!sheet) buildSheet();
    var item = list[0];
    var SHORT = { 'fruit-fly-defense-deterrents-sink-drops': 'Combo Pack', 'fruit-fly-deterrent': 'Starter Pack', 'fruit-fly-defense-sink-dropper': 'Sink Drops', 'fruit-fly-deterrent-power-up-pack': 'Power Up Pack' };
    var short = function (i) { return SHORT[i.handle] || i.product_title; };
    var title = list.map(short).join(' + ');
    var total = list.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var plan = item.selling_plan_allocation ? ', ' + item.selling_plan_allocation.selling_plan.name.toLowerCase() : '';
    var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    sheet.querySelector('.fx-sheet__item').innerHTML = (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
      '<div><b>' + title + '</b><span>' + money(total) + plan + '</span></div>';
    var up = upsellFor ? D.up[String(upsellFor)] : null, upw = sheet.querySelector('.fx-sheet__upw');
    upw.innerHTML = '';
    if (up && D.p[up.k]) {
      var p = D.p[up.k];
      upw.innerHTML = '<div class="fx-sheet__up"><img src="' + p.img + '" alt=""><div><b>' + up.t + '</b><span>' + up.s + '</span></div>' +
        '<button type="button" class="fx-btn fx-btn--forest" data-fx-add=\'[{"id":' + p.id + ',"quantity":1}]\' data-fx-inline>' + up.b + '</button></div>';
    }
    lastFocus = document.activeElement;
    sheet.classList.add('is-open');
    sheet.querySelector('.fx-sheet__panel').focus();
  }

  /* ---------- generic add buttons: data-fx-add='[{"id":..,"quantity":1}]' ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fx-add]'); if (!b) return;
    var items; try { items = JSON.parse(b.getAttribute('data-fx-add')); } catch (x) { return; }
    if (!items.length) return;
    e.preventDefault(); b.setAttribute('aria-busy', 'true');
    add(items).then(function (j) {
      b.removeAttribute('aria-busy');
      if (b.hasAttribute('data-fx-inline')) { var w = b.closest('.fx-sheet__up'); if (w) w.outerHTML = '<p class="fx-sheet__ship" style="color:#2f6b1a;font-weight:600">Added. Any discount shows at checkout.</p>'; return; }
      openSheet(j.items || [j], (b.hasAttribute('data-fx-nosell') || items.length > 1) ? null : items[0].id);
    }).catch(function () { b.removeAttribute('aria-busy'); var h = b.getAttribute('href'); if (h && h.charAt(0) !== '#') window.location.href = h; });
  });

  /* ---------- sticky bar: shows whenever the main buy button is off screen ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-fx-sticky]'); var trig = document.querySelector('[data-fx-sticky-after]');
    if (!bar || !trig || !('IntersectionObserver' in window)) return;
    document.body.classList.add('fx-has-sticky');
    new IntersectionObserver(function (es) { bar.classList.toggle('is-on', !es[0].isIntersecting); }).observe(trig);
  }

  /* ---------- product page ---------- */
  function initPdp() {
    var f = document.querySelector('[data-fx-pdp]'); if (!f) return;
    var atc = f.querySelector('[data-fx-atc]'), qty = f.querySelector('[data-fx-qty]'), sp = f.querySelector('input[name="selling_plan"]');
    var addon = f.querySelector('[data-fx-addon]');
    var stickyBtn = document.querySelector('[data-fx-sticky-atc]'), stickyPrice = document.querySelector('[data-fx-sticky-price]');
    var vid = parseInt(f.getAttribute('data-variant'), 10);
    function plan() { return f.querySelector('input[name="fx-plan"]:checked'); }
    function q() { var n = Math.max(1, parseInt(qty.value, 10) || 1); qty.value = n; return n; }
    function build() {
      var o = plan(), sub = o.value === 'sub', n = q(), items = [], total = 0;
      if (addon && addon.checked && addon.dataset.mode === 'swap') {
        var it = { id: +addon.dataset.id, quantity: n }; if (sub && addon.dataset.plan) it.selling_plan = +addon.dataset.plan;
        items.push(it); total = (sub ? +addon.dataset.sub : +addon.dataset.price) * n;
      } else {
        var main = { id: vid, quantity: n }; if (sub) main.selling_plan = +o.dataset.plan;
        items.push(main); total = +o.dataset.price * n;
        if (addon && addon.checked && addon.dataset.mode === 'add') { items.push({ id: +addon.dataset.id, quantity: 1 }); total += +addon.dataset.price; }
      }
      return { items: items, total: total, sub: sub };
    }
    function render() {
      var b = build();
      atc.textContent = (b.sub ? 'Subscribe, ' : 'Add to cart, ') + money(b.total) + (b.sub ? '/mo' : '');
      if (sp) sp.value = b.sub ? plan().dataset.plan : '';
      if (stickyPrice) stickyPrice.textContent = money(b.total) + (b.sub ? ' a month, Subscribe & Save' : (b.total >= 3500 ? ', ships free' : ', free shipping over $35'));
    }
    f.addEventListener('change', render);
    f.addEventListener('click', function (e) {
      var s = e.target.closest('[data-fx-step]'); if (!s) return;
      e.preventDefault(); qty.value = Math.max(1, q() + parseInt(s.getAttribute('data-fx-step'), 10)); render();
    });
    function go(btn) {
      var b = build(); btn.setAttribute('aria-busy', 'true');
      add(b.items).then(function (j) { btn.removeAttribute('aria-busy'); var list = j.items || [j]; openSheet(list, b.items.length > 1 || b.items[0].id !== vid ? null : vid); })
        .catch(function () { btn.removeAttribute('aria-busy'); f.submit(); });
    }
    f.addEventListener('submit', function (e) { e.preventDefault(); go(atc); });
    if (stickyBtn) stickyBtn.addEventListener('click', function (e) { e.preventDefault(); go(stickyBtn); });
    render();
  }

  /* ---------- gallery ---------- */
  function initGallery() {
    var g = document.querySelector('[data-fx-gal]'); if (!g) return;
    var track = g.querySelector('.fx-gal__track'), slides = track.children, dots = g.querySelectorAll('.fx-gal__dots button'), th = g.querySelectorAll('.fx-gal__thumbs button');
    function go(i) { if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    function mark(i) { [].forEach.call(dots, function (d, k) { d.classList.toggle('on', k === i); }); [].forEach.call(th, function (d, k) { d.classList.toggle('on', k === i); }); }
    [].forEach.call(dots, function (d, i) { d.addEventListener('click', function () { go(i); }); });
    [].forEach.call(th, function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var t; track.addEventListener('scroll', function () {
      clearTimeout(t); t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth); mark(i);
        [].forEach.call(track.querySelectorAll('video'), function (v) { if (v.closest('.fx-gal__slide') !== slides[i]) v.pause(); });
      }, 60);
    }, { passive: true });
  }

  /* ---------- kitchen map: recommend the smallest kit that covers the tapped spots ---------- */
  function initKitMap() {
    var m = document.querySelector('[data-fx-kitmap]'); if (!m || !D.p.combo) return;
    var P = D.p, rooms = 0;
    var el = function (s) { return m.querySelector(s); };
    var spots = m.querySelectorAll('[data-spot]'), lastPrice = 0;
    function on(k) { var b = m.querySelector('[data-spot="' + k + '"]'); return b && b.getAttribute('aria-pressed') === 'true'; }
    var photos = m.querySelectorAll('[data-build-photo] img'), cap = m.querySelector('[data-build-caption]');
    function showPhoto(k) {
      var hit = null;
      [].forEach.call(photos, function (im) { var on = im.getAttribute('data-photo') === k; im.classList.toggle('is-on', on); if (on) hit = im; });
      if (hit && cap) cap.textContent = hit.getAttribute('data-caption') || '';
    }
    function setSpot(k, v) {
      [].forEach.call(m.querySelectorAll('[data-spot="' + k + '"]'), function (b) { b.setAttribute('aria-pressed', v ? 'true' : 'false'); });
      if (v) showPhoto(k); else { var first = ['fruit', 'sink', 'trash', 'drain'].filter(on)[0]; if (first) showPhoto(first); }
    }
    function tween(el, from, to) {
      if (!to || from === to || !window.requestAnimationFrame) { el.textContent = to ? money(to) : ''; return; }
      var t0 = performance.now(), d = 420;
      (function step(t) { var p = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - p, 3); el.textContent = money(Math.round(from + (to - from) * e)); if (p < 1) requestAnimationFrame(step); })(t0);
    }
    function names(list) { return list.length === 1 ? list[0] : list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1]; }
    function render() {
      var where = [];
      if (on('fruit')) where.push('your fruit bowl'); if (on('sink')) where.push('the sink'); if (on('trash')) where.push('the trash and compost');
      if (rooms) where.push(rooms === 1 ? 'one more room' : rooms + ' more rooms');
      var discs = (on('fruit') ? 1 : 0) + (on('sink') ? 1 : 0) + (on('trash') ? 1 : 0) + rooms, drain = on('drain');
      var k = { name: '', what: '', price: 0, was: 0, items: [], url: '#', why: '', img: 'combo' };
      var cover = where.length ? 'A disc for ' + names(where) : '';
      if (!discs && !drain) {
        k.name = 'Pick a spot'; k.what = 'Tap where you see fruit flies.'; k.why = 'Fruit bowl, sink, trash or the drain. Pick as many as apply.';
      } else if (!discs) {
        k.name = 'Sink Drops'; k.img = 'drops'; k.what = '1 bottle for your kitchen drains'; k.price = P.drops.price; k.items = [{ id: P.drops.id, quantity: 1 }]; k.url = P.drops.url;
        k.why = 'Drops for the drain, where fruit flies breed out of sight. If you also see them around fruit or trash, tap those spots too.';
      } else if (discs <= 3) {
        if (drain) { k.name = 'Combo Pack'; k.what = '3 discs + Sink Drops'; k.price = P.combo.price; k.was = P.starter.price + P.drops.price; k.items = [{ id: P.combo.id, quantity: 1 }]; k.url = P.combo.url; }
        else { k.name = 'Starter Pack'; k.img = 'starter'; k.what = '3 deterrent discs'; k.price = P.starter.price; k.items = [{ id: P.starter.id, quantity: 1 }]; k.url = P.starter.url; }
        k.why = cover + (drain ? ', plus Sink Drops for the drain.' : '.') + (discs < 3 ? ' The extra discs are your refills for the next round.' : '');
      } else if (discs <= 6) {
        if (drain) { k.name = 'Combo + 3 discs'; k.what = '6 discs + Sink Drops'; k.price = P.combo.price + (D.stock ? Math.round(P.starter.price / 2) : P.starter.price); k.was = P.combo.price + P.starter.price; k.items = [{ id: P.combo.id, quantity: 1 }, { id: P.starter.id, quantity: 1 }]; k.url = P.combo.url; }
        else { k.name = '2 Starter Packs'; k.img = 'starter'; k.what = '6 deterrent discs'; k.price = P.starter.price * 2; k.items = [{ id: P.starter.id, quantity: 2 }]; k.url = P.starter.url; }
        k.why = cover + (drain ? ', plus Sink Drops for the drain.' : '.') + (discs < 6 ? ' Spare discs are your refills.' : '');
        if (drain && !D.stock) k.was = 0;
      } else {
        k.name = 'Power Up Pack' + (drain ? ' + Sink Drops' : ''); k.img = 'power'; k.what = '12 discs' + (drain ? ' + Sink Drops' : ''); k.price = P.power.price + (drain ? P.drops.price : 0);
        k.items = [{ id: P.power.id, quantity: 1 }].concat(drain ? [{ id: P.drops.id, quantity: 1 }] : []); k.url = P.power.url;
        k.why = cover + (drain ? ', plus Sink Drops for the drain.' : '.') + ' The lowest price per disc we offer.';
      }
      el('[data-kit-name]').textContent = k.name; el('[data-kit-name]').setAttribute('href', k.url);
      el('[data-kit-what]').textContent = k.what; el('[data-kit-why]').textContent = k.why;
      tween(el('[data-kit-price]'), lastPrice, k.price); lastPrice = k.price;
      var im = el('[data-kit-img]'); if (im && P[k.img] && P[k.img].img && im.getAttribute('src') !== P[k.img].img) { im.classList.add('is-swap'); setTimeout(function () { im.src = P[k.img].img; im.onload = function () { im.classList.remove('is-swap'); }; }, 120); }
      el('[data-kit-was]').textContent = k.was && k.was > k.price ? money(k.was) + ' separately' : '';
      var btn = el('[data-kit-add]'); btn.setAttribute('data-fx-add', JSON.stringify(k.items)); btn.disabled = !k.items.length;
      btn.textContent = k.items.length ? 'Add this kit, ' + money(k.price) : 'Add this kit';
      if (k.items.length > 1) btn.setAttribute('data-fx-nosell', ''); else btn.removeAttribute('data-fx-nosell');
      el('[data-rooms-out]').textContent = rooms;
      var sel = el('[data-kit-sel]'); if (sel) { var cnt = ['fruit', 'sink', 'trash', 'drain'].filter(on).length; sel.textContent = cnt ? 'Your kit covers ' + cnt + ' of 4 spots' + (rooms ? ' and ' + rooms + ' more room' + (rooms > 1 ? 's' : '') : '') : 'Tap a spot to start your kit'; }
    }
    [].forEach.call(spots, function (b) { b.addEventListener('click', function () { setSpot(b.getAttribute('data-spot'), b.getAttribute('aria-pressed') !== 'true'); render(); }); });
    ['fruit', 'sink', 'trash', 'drain'].forEach(function (k) { setSpot(k, on(k)); });
    m.addEventListener('click', function (e) { var r = e.target.closest('[data-rooms]'); if (!r) return; rooms = Math.min(9, Math.max(0, rooms + parseInt(r.getAttribute('data-rooms'), 10))); render(); });
    render();
  }

  function initHero() {
    var h = document.querySelector('[data-fx-hero]'); if (!h) return;
    var c = h.querySelector('[data-fx-canvas]'), disc = h.querySelector('[data-fx-disc]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!c || !c.getContext) return;
    var ctx = c.getContext('2d'), W = 0, H = 0, P = [], N = 0, cx = 0, cy = 0, R = 1, t = 0, raf = 0, live = false;
    var A = [{ a: 0, s: .09 }, { a: 2.1, s: .07 }, { a: 4.2, s: .11 }, { a: 1.2, s: .05 }];
    function spawn(edge) {
      var p = { x: 0, y: 0, vx: 0, vy: 0, s: .8 + Math.random() * 1.1, o: .35 + Math.random() * .5, ph: Math.random() * 6.283, w: 6 + Math.random() * 6, k: Math.random() * A.length | 0 };
      if (edge) { var side = Math.random() * 4 | 0; p.x = side === 0 ? -10 : side === 1 ? W + 10 : Math.random() * W; p.y = side === 2 ? -10 : side === 3 ? H + 10 : Math.random() * H; }
      else { do { p.x = Math.random() * W; p.y = Math.random() * H; } while (Math.hypot(p.x - cx, p.y - cy) < R * 1.8); }
      return p;
    }
    function size() {
      var r = h.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
      W = r.width; H = r.height; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var d = disc ? disc.getBoundingClientRect() : { left: W * .7, top: H * .5, width: 10, height: 10 }; cx = d.left - r.left + d.width / 2; cy = d.top - r.top + (d.height || d.width) / 2; R = Math.max(d.width, d.height || d.width) / 2;
      N = Math.max(W < 700 ? 40 : 90, Math.min(260, Math.round(W * H / (W < 700 ? 9000 : 6500))));
      P = []; for (var i = 0; i < N; i++) P.push(spawn(false));
      if (reduce) draw();
    }
    function glow() {
      var g = ctx.createRadialGradient(cx, cy, R * .95, cx, cy, R * 3.4);
      g.addColorStop(0, 'rgba(194,220,58,.20)'); g.addColorStop(.3, 'rgba(194,220,58,.08)'); g.addColorStop(.7, 'rgba(194,220,58,.02)'); g.addColorStop(1, 'rgba(194,220,58,0)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      var v = ctx.createRadialGradient(W * .55, H * .5, Math.min(W, H) * .35, W * .55, H * .5, Math.max(W, H) * .8);
      v.addColorStop(0, 'rgba(0,0,0,0)'); v.addColorStop(1, 'rgba(0,0,0,.45)');
      ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
    }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 1.1;
      glow();
      var zone = R * 1.7;
      for (var j = 0; j < A.length; j++) { var at = A[j]; at.x = W * (.5 + .46 * Math.sin(at.a + t * at.s)); at.y = H * (.5 + .4 * Math.cos(at.a * 1.7 + t * at.s * 1.3)); }
      ctx.strokeStyle = '#f3efe5'; ctx.fillStyle = '#f3efe5';
      for (var i = 0; i < N; i++) {
        var p = P[i], at2 = A[p.k];
        var ax = at2.x - p.x, ay = at2.y - p.y, al = Math.hypot(ax, ay) || 1;
        p.vx += ax / al * .045; p.vy += ay / al * .045;
        p.vx += Math.cos(t * p.w + p.ph) * .24; p.vy += Math.sin(t * p.w * 1.3 + p.ph * 1.9) * .24;
        var dx = p.x - cx, dy = p.y - cy, d = Math.hypot(dx, dy) || 1;
        if (d < zone) { var g = (zone - d) / zone; g = g * g * 1.6 + .08; p.vx += dx / d * g; p.vy += dy / d * g; }
        p.vx *= .9; p.vy *= .9; p.x += p.vx; p.y += p.vy;
        if (p.x < -14 || p.x > W + 14 || p.y < -14 || p.y > H + 14) { var n = spawn(true); p.x = n.x; p.y = n.y; p.vx = p.vy = 0; }
        ctx.globalAlpha = p.o;
        ctx.beginPath(); ctx.moveTo(p.x - p.vx * 2.2, p.y - p.vy * 2.2); ctx.lineTo(p.x, p.y); ctx.stroke();
        ctx.beginPath(); ctx.arc(p.x, p.y, p.s, 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    function loop() { t += .016; draw(); raf = requestAnimationFrame(loop); }
    function start() { if (!live && !reduce) { live = true; raf = requestAnimationFrame(loop); } }
    function stop() { live = false; cancelAnimationFrame(raf); }
    var to; window.addEventListener('resize', function () { clearTimeout(to); to = setTimeout(size, 150); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }).observe(h); else start();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(size); size();
    if (disc) { var im = disc.querySelector('img'); if (im && !im.complete) im.addEventListener('load', size); }
  }
  function initReveal() {
    var els = document.querySelectorAll('[data-fx-reveal]'); if (!els.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: .3 });
    [].forEach.call(els, function (el) { el.classList.add('is-armed'); io.observe(el); });
  }
  function init() { initSticky(); initPdp(); initGallery(); initKitMap(); initHero(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
